import { Pagination } from '@celltrak/ui-components';

import { useAction } from '../../../Common/hooks';
import { setRejectedPagination } from '../../actions';

import usePagination from './hooks';

const Paginator = () => {
  const { numberOfPages, pagesPerSegment, pageNumber } = usePagination();
  const dispatchSetRejectedPagination = useAction(setRejectedPagination);

  return (
    <Pagination
      size="sm"
      id="rejected-reports-pager"
      pages={numberOfPages}
      activePage={pageNumber}
      pagesPerSegment={pagesPerSegment}
      onPageClick={page => dispatchSetRejectedPagination({ pageNumber: page })}
      onFirstClick={() => dispatchSetRejectedPagination({ pageNumber: 1 })}
      onPrevClick={() => dispatchSetRejectedPagination({ pageNumber: pageNumber - 1 })}
      onNextClick={() => dispatchSetRejectedPagination({ pageNumber: pageNumber + 1 })}
      onLastClick={() => dispatchSetRejectedPagination({ pageNumber: numberOfPages })}
    />
  );
};

export default Paginator;
